import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(public auth: AuthenticationService, private router: Router){}

  async canActivate(): Promise<boolean> {
    const isAuth = await this.auth.isAuthenticated();  // Usa `await` per aspettare il risultato di `isAuthenticated()`
    // console.info("Is user authenticated:", isAuth);
    if (!isAuth) {
      this.router.navigate(["login"]);
    }
    return isAuth;  // Restituisce true o false in base all'autenticazione
  }
  
}
